/**
 * api接口的统一出口
 */
//用户模块接口
import user from '@/api/user';
//量化交易接口
import trade from '@/api/trade';
//配置接口
import config from '@/api/config';
//0运营监控
import monitor from '@/api/monitor';
import client from '@/api/client';
import trader from '@/api/trader';
import statistics from '@/api/statistics';
// 导出接口
export default {
  user:user,
  trade:trade,
  config:config,
  monitor:monitor,
  client:client,
  trader:trader,
  statistics:statistics,
}



// WEBPACK FOOTER //
// ./src/api/index.js